import { useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { PolicyService } from 'gw-capability-policy';
import { DocumentService } from 'gw-capability-policydocument';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import FileUploadViewerComponent from '../FileUploadViewerComponent/FileUploadViewerComponent'
import messages from './PolicyDocumentsAccordion.messages';
import metadata from './PolicyDocumentsAccordion.metadata.json5';
import styles from './PolicyDocumentsAccordion.module.scss';

function PolicyDocumentsAccordion(props) {
    const { showAlert, showConfirm } = useModal();

    const {
        value: {
            documentDTOs: policyCommonDocuments,
            policyNumber,
            canUploadDocument,
        },
        writableDocuments,
        updateWritableDocuments,
    } = props;
    const { authHeader } = useAuthentication();
    const publicDocuments = useMemo(() => {
        return _.filter(policyCommonDocuments, document => {
            return !document.isAuthor;
        });
    }, [policyCommonDocuments]);

    useEffect(() => {
        const writableDoc = _.filter(policyCommonDocuments, document => {
            return document.isAuthor;
        });
        updateWritableDocuments(writableDoc);
    }, [policyCommonDocuments, updateWritableDocuments]);

    const getDocumentDownloadLink = useCallback(item => {
        const { docUID, sessionID } = item;
        const downloadURL = DocumentService.downloadOfferDocument(docUID, sessionID);
        const policyNo = !_.isUndefined(item.policyNumber) ?item.policyNumber : ''
        const jobNumber = !_.isUndefined(item.jobNumber) ?item.jobNumber : ''
        const accountNumber = !_.isUndefined(item.accountNumber) ?item.accountNumber : ''
        const url = `${downloadURL}&account=${accountNumber}&policyNumber=${policyNo}&job=${jobNumber}&portalRoute=/account-management/PolicyDocumentError`;

        return url;
    }, []);

    const overrides = {
        policyDocuments: {
            visible: !_.isEmpty(publicDocuments),
        },
        readOnlyDocumentFileUploadComponent: {
            data: {
                isReadOnly: true,
                documents: publicDocuments,
            },
            getDownloadLink: getDocumentDownloadLink,
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            documentscomponent: FileUploadViewerComponent,
        },
        resolveCallbackMap: {

        },
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.componentContent,
                policyCommonDocuments,
                id,
                path,
                overrides
            );
        },
        [policyCommonDocuments, overrides]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyCommonDocuments}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
        />
    );
}

PolicyDocumentsAccordion.propTypes = {
    value: PropTypes.shape({
        documentDTOs: PropTypes.arrayOf(PropTypes.shape({})),
        policyNumber: PropTypes.string,
        canUploadDocument: PropTypes.bool,
    }),
    writableDocuments: PropTypes.shape([]).isRequired,
    updateWritableDocuments: PropTypes.shape([]).isRequired,
};

PolicyDocumentsAccordion.defaultProps = {
    value: {
        documentDTOs: [],
        policyNumber: '',
        canUploadDocument: false,
    },
};

export default withRouter(PolicyDocumentsAccordion);
